import { trackEvent } from '@patrianna/analytics'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import authPages from 'prismic-translates/auth-pages.json'

import classes from '../styles.module.scss'

import RegisterForm from './RegisterForm'

const t = getTranslationFromJson([authPages])

function Register() {
  const onClick = () => {
    trackEvent('register_manual_page_login_link')
  }

  return (
    <>
      <RegisterForm />

      <p className={classes.accountLink}>
        {t('already_got_account')}?{' '}
        <Link href={ROUTES.LOGIN} prefetch={false}>
          <span className={classes.link} data-test='go-to-register-modal' onClick={onClick}>
            {t('log_in')}
          </span>
        </Link>
      </p>
    </>
  )
}

export default Register
